import React from 'react';
import PageHero from '../components/PageHero';
import FinalCTA from '../components/FinalCTA';
import { FAQs } from '../constants';
import RevealOnScroll from '../components/RevealOnScroll';
import { Link } from 'react-router-dom';

const FAQPage: React.FC = () => {
    return (
        <>
            <PageHero
                title="Frequently Asked Questions"
                subtitle="Find answers to common questions about shipping, storage, and customs."
            />

            <section className="py-12 md:py-20 bg-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    {FAQs.map((category, idx) => (
                        <RevealOnScroll key={idx} className="mb-10 md:mb-12">
                            <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 md:mb-6 border-b border-slate-100 pb-2">{category.category}</h3>
                            <div className="space-y-3 md:space-y-4">
                                {category.items.map((item, i) => (
                                    <details key={i} className="group bg-slate-50 rounded-xl p-4 [&_summary::-webkit-details-marker]:hidden open:bg-brand-50 open:ring-1 open:ring-brand-200 transition-all">
                                        <summary className="flex cursor-pointer items-center justify-between font-medium text-slate-900 text-sm md:text-base">
                                            {item.question}
                                            <span className="shrink-0 transition duration-300 group-open:-rotate-180 ml-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-500 group-open:text-brand-600" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                                </svg>
                                            </span>
                                        </summary>
                                        <p className="mt-3 md:mt-4 leading-relaxed text-slate-600 text-xs md:text-sm">
                                            {item.answer}
                                        </p>
                                    </details>
                                ))}
                            </div>
                        </RevealOnScroll>
                    ))}

                    <RevealOnScroll className="mb-12">
                        <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 md:mb-6 border-b border-slate-100 pb-2">Rules & Policies</h3>
                        <div className="bg-slate-50 rounded-xl p-4 md:p-6">
                            <h4 className="font-bold text-slate-900 text-base md:text-lg">What items are prohibited?</h4>
                            <p className="mt-2 text-slate-600 text-xs md:text-sm mb-3">
                                We strictly prohibit dangerous goods, illegal items, and certain restricted materials.
                                For a complete list of prohibited items, packaging requirements, and customs policies, please review our detailed rules.
                            </p>
                            <Link to="/home/rules" className="text-brand-600 font-bold hover:underline text-xs md:text-sm">
                                View Full Rules & Regulations &rarr;
                            </Link>
                        </div>
                    </RevealOnScroll>

                    <div className="mt-8 md:mt-12 text-center bg-blue-50 p-6 md:p-8 rounded-2xl border border-blue-100">
                        <h4 className="font-bold text-slate-900 text-base md:text-lg mb-2">Still have questions?</h4>
                        <p className="text-slate-600 mb-4 md:mb-6 text-sm">Our support team is just a message away.</p>
                        <a href="/contact" className="bg-brand-600 text-white font-bold px-6 py-3 rounded-lg hover:bg-brand-700 transition inline-block text-sm md:text-base">Contact Support</a>
                    </div>
                </div>
            </section>

            <FinalCTA />
        </>
    );
};

export default FAQPage;